import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=42b877c5&scoped=true"
import script from "./LoginPhone.vue?vue&type=script&lang=js"
export * from "./LoginPhone.vue?vue&type=script&lang=js"
import style0 from "./LoginPhone.vue?vue&type=style&index=0&id=42b877c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b877c5",
  null
  
)

export default component.exports